import React from "react";

/**
 * Gallery (Home) line-art house icon — ISP-9999 (Kelly, 2026-08-27).
 *
 * Matches the mobile app's gallery tab icon (assessed from Kelly's IMG_7998):
 * an outline house — peaked roof + square body — with a rectangular door
 * cutout inset bottom-center. Stroke-only line-art (fill="none"), same
 * convention as this header's other hand-authored icon, CaptureFrame.jsx:
 * `color` defaults to the app's PrimaryPurple500 token value (#9B5AF8).
 * `strokeLinejoin="round"` / `strokeLinecap="round"` soften the peak and
 * corners; the door is drawn as its own path so the opening is a true
 * cutout — the background shows through it — rather than a filled overlay.
 * This deliberately replaces MUI's HomeOutlined (used previously), which has
 * no door and is a filled path rather than an actual stroke.
 */
const HouseLineArt = ({ color = "#9B5AF8", width = 26, height = 26, strokeWidth = 8 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* House outline: peaked roof + square body */}
    <path
      d="M22 100 L22 56 L64 20 L106 56 L106 100 Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Door cutout: inset bottom-center, true cutout (fill="none" above) */}
    <path
      d="M46 100 L46 68 L82 68 L82 100"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HouseLineArt;
